import { render, staticRenderFns } from "./CandidatesHeaders.vue?vue&type=template&id=8e47cf6a&scoped=true&lang=pug"
import script from "./CandidatesHeaders.vue?vue&type=script&lang=js"
export * from "./CandidatesHeaders.vue?vue&type=script&lang=js"
import style0 from "./CandidatesHeaders.vue?vue&type=style&index=0&id=8e47cf6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e47cf6a",
  null
  
)

export default component.exports